import React from 'react';
import { ChevronDown } from 'lucide-react';
interface FilterDropdownProps {
  label?: string;
  value: string;
  options?: string[];
  onChange?: (value: string) => void;
  className?: string;
}
export function FilterDropdown({
  label,
  value,
  options = [],
  onChange,
  className = ''
}: FilterDropdownProps) {
  return <div className={`relative group ${className}`} data-id="element-637">
     
      <div className="relative" data-id="element-638">
        <select value={value} onChange={e => onChange && onChange(e.target.value)} className="appearance-none w-full px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-black focus:border-black transition-all duration-200 cursor-pointer pr-8" data-id="element-639">
          {options.map(option => <option key={option} value={option} data-id="element-640">
              {option}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-641">
          <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-642" />
        </div>
      </div>
    </div>;
}